import React,{useRef,useCallback,useState} from 'react';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import Webcam from "react-webcam";
import { setCameraImage } from './features/cameraSlice';
import {useDispatch} from "react-redux";
import { useHistory } from 'react-router';
import "./WebcamCapture.css";
const videoConstraints ={
    width: 250,
 height:400,
 facingMode:"user"   
};


export default function Webcamcapture() {
    const webcamRef=useRef(null);
    const dispatch = useDispatch();
   const history = useHistory();
  //  const [image,setImage] = useState(null);
const capture = useCallback( () => {
        const imageSrc = webcamRef.current.getScreenshot();
       dispatch(setCameraImage(imageSrc));


        //console.log(imageSrc);
   //  setImage(imageSrc);
    history.push("/preview");
    },
    [webcamRef],
)
    return (
        <div className="webcamCapture">
            <Webcam
            audio={false}
            height={videoConstraints.height}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            width={videoConstraints.width}
            videoConstraints={videoConstraints}



            />
            <RadioButtonUncheckedIcon
            className="webcamCapture__button"
            onClick={capture}
            fontSize="large"
            />
    
        </div>
    )
}
